import React from 'react';
import { typography, palette, withOpacity } from '../../../../utils/designTokens';
import { formatContent } from '../../../../utils/contentFormatters';
import { logger } from '../../../../utils/logger';

/**
 * RawValueDisplay - Displays raw input.value or output.value
 * Used in Input/Output tabs after structured data (messages, documents)
 *
 * @param {string|Object} value - Raw value to display
 * @param {string} label - Section label (e.g., "Raw Input", "Raw Output")
 */
const RawValueDisplay = ({ value, label = 'Raw Value' }) => {
  if (value === undefined || value === null) {
    return null; // Don't render if no value
  }

  logger.debug('RawValueDisplay rendering:', { label, valueType: typeof value });

  let displayContent;
  let hasError = false;

  try {
    displayContent = formatContent(value);
  } catch (e) {
    logger.error('Failed to format content in RawValueDisplay:', e);
    hasError = true;
    displayContent = String(value);
  }

  return (
    <div className="space-y-2">
      <div
        className="font-medium"
        style={{
          fontSize: typography.size.sm,
          color: palette.text.secondary
        }}
      >
        {label}
      </div>
      <div
        className="p-3 rounded border font-mono whitespace-pre-wrap break-words"
        style={{
          fontSize: typography.size.xs,
          backgroundColor: hasError
            ? withOpacity(palette.status.danger, 6)
            : palette.neutrals.panelSecondary,
          borderColor: hasError
            ? palette.status.danger
            : palette.borders.subtle,
          color: palette.text.primary
        }}
      >
        {hasError && (
          <div
            className="mb-2 text-xs"
            style={{ color: palette.status.danger }}
          >
            ⚠️ Error formatting content - showing raw value
          </div>
        )}
        {displayContent}
      </div>
    </div>
  );
};

export default RawValueDisplay;
